import { useNavigate, useLocation } from 'react-router-dom';
import {
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Toolbar,
  Divider,
  Box,
  Typography
} from '@mui/material';
import DashboardIcon from '@mui/icons-material/Dashboard';
import PeopleIcon from '@mui/icons-material/People';
import AssessmentIcon from '@mui/icons-material/Assessment';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import ShareOutlinedIcon from '@mui/icons-material/ShareOutlined';
import SettingsIcon from '@mui/icons-material/Settings';
import MosqueIcon from '@mui/icons-material/Mosque';
import DarkModeIcon from '@mui/icons-material/DarkMode';
import { headerHeight } from './Header';

export const drawerWidth = 284;

const menuItems = [
  { text: 'Genel Bakış', icon: <DashboardIcon />, path: '/dashboard' },
  { text: 'Kullanıcılar', icon: <PeopleIcon />, path: '/users' },
  { text: 'Raporlar', icon: <AssessmentIcon />, path: '/reports' },
  { text: 'Kart Paylaşımları', icon: <ShareOutlinedIcon />, path: '/card-shares' },
  { text: 'Destek', icon: <SupportAgentIcon />, path: '/support' },
  { text: 'Ayarlar', icon: <SettingsIcon />, path: '/settings' }
];

function Sidebar({ isDesktop, mobileOpen, onClose }) {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <Drawer
      variant={isDesktop ? 'permanent' : 'temporary'}
      open={isDesktop || mobileOpen}
      onClose={onClose}
      ModalProps={{ keepMounted: true }}
      PaperProps={{ component: 'nav', id: 'admin-navigation', 'aria-label': 'Ana menü' }}
      sx={{
        width: { xs: 0, md: drawerWidth },
        flexShrink: 0,
        '& .MuiDrawer-paper': {
          width: drawerWidth,
          boxSizing: 'border-box',
          background: 'linear-gradient(145deg, #111d31, #18263c)',
          color: '#cbd6eb',
          borderRight: '1px solid #24324a'
        }
      }}
    >
      <Toolbar sx={{ minHeight: headerHeight, gap: 1.5, py: 1 }}>
        <MosqueIcon sx={{ fontSize: 42, color: '#38a5f5' }} />
        <Box sx={{ py: 1 }}>
          <Typography
            variant="h6"
            noWrap
            component="div"
            sx={{
              fontWeight: 800,
              fontSize: '17px',
              color: 'white'
            }}
          >
            İbadet Takibi Admin
          </Typography>
          <Typography sx={{ color: 'rgba(255,255,255,0.62)', fontSize: '12px', mt: 0.25 }}>
            Operasyon ve raporlama paneli
          </Typography>
        </Box>
      </Toolbar>
      <Divider sx={{ borderColor: 'rgba(255,255,255,0.1)' }} />
      <List sx={{ px: 2, pt: 2 }}>
        {menuItems.map((item) => (
          <ListItem key={item.text} disablePadding sx={{ mb: 1 }}>
            <ListItemButton
              onClick={() => {
                navigate(item.path);
                onClose();
              }}
              selected={location.pathname === item.path}
              aria-current={location.pathname === item.path ? 'page' : undefined}
              sx={{
                borderRadius: '12px',
                minHeight: 50,
                transition: 'all 0.3s',
                '&.Mui-selected': {
                  backgroundColor: '#1460f4',
                  color: '#fff',
                  boxShadow: '0 5px 16px #0961ff30',
                  '&:hover': {
                    backgroundColor: '#1D4ED8'
                  }
                },
                '&:hover': {
                  backgroundColor: 'rgba(255,255,255,0.08)'
                }
              }}
            >
              <ListItemIcon sx={{ color: 'inherit', minWidth: 46 }}>
                {item.icon}
              </ListItemIcon>
              <ListItemText
                primary={item.text}
                primaryTypographyProps={{
                  fontWeight: location.pathname === item.path ? 700 : 500,
                  fontSize: '15px'
                }}
              />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
      <Box sx={{ m: 2, mt: 'auto', p: 2, border: '1px solid #2b3a53', borderRadius: 3, display: 'flex', alignItems: 'center', gap: 2, background: '#ffffff03' }}>
        <DarkModeIcon sx={{ color: '#60b5ff', fontSize: 44 }} />
        <Typography sx={{ fontSize: 13, lineHeight: 1.8 }}>Daha iyi bir<br />manevi gelecek için</Typography>
      </Box>
    </Drawer>
  );
}

export default Sidebar;
